import FieldsInterface from "@app/Interface/FieldsInterface";
import UserModel from "@app/Model/UserModel";

export function getMyAccountFields(currentUser: UserModel): FieldsInterface {

    /**
     * Get the fields for updating the user
     */
    const myAccountFields: FieldsInterface = {
        emailAddress: {
            fieldId: "emailAddress",
            formFieldId: "emailAddress",
            value: currentUser.email,
            label: "Login/Email",
            validated: "default",
            required: true,
            validateAgainst: "isEmail",
            helperTextInvalid: "Please enter a valid email address."
        },
        firstName: {
            fieldId: "firstName",
            formFieldId: "firstName",
            value: currentUser.firstName,
            label: "First Name",
            validated: "default",
            required: true,
            helperTextInvalid: "Required field."
        },
        lastName: {
            fieldId: "lastName",
            formFieldId: "lastName",
            value: currentUser.lastName,
            label: "Last Name",
            validated: "default",
            required: true
        },
        contactName: {
            fieldId: "contactName",
            formFieldId: "contactName",
            value: currentUser.contactName,
            label: "Contact Name",
            validated: "default",
            required: false
        },
        phoneNumber: {
            fieldId: "phoneNumber",
            formFieldId: "phoneNumber",
            value: currentUser.phoneNumber,
            label: "Phone Number",
            validated: "default",
            required: false,
            helperTextInvalid: "Please enter a valid phone number."
        },
        cellNumber: {
            fieldId: "cellNumber",
            formFieldId: "cellNumber",
            value: currentUser.cellNumber,
            label: "Cell Number",
            validated: "default",
            required: false,
            helperTextInvalid: "Please enter a valid cell phone number."
        },
        address1: {
            fieldId: "address1",
            formFieldId: "address1",
            value: currentUser.address,
            label: "Address Line 1",
            validated: "default",
            required: false
        },
        address2: {
            fieldId: "address2",
            formFieldId: "address2",
            value: currentUser.address2,
            label: "Address Line 2",
            validated: "default",
            required: false
        },
        city: {
            fieldId: "city",
            formFieldId: "city",
            value: currentUser.city,
            label: "City",
            validated: "default",
            required: false
        },
        state: {
            fieldId: "state",
            formFieldId: "state",
            value: currentUser.state,
            label: "State",
            validated: "default",
            required: false
        },
        zip: {
            fieldId: "zip",
            formFieldId: "zip",
            value: currentUser.zip,
            label: "Zip",
            validated: "default",
            required: false
        }

    }

    return myAccountFields;

}

/**
 * Get userdata for posting to middleware
 * @param currentUser 
 * @param formFields 
 * @returns 
 */
export const getUserDataForPost = (currentUser: UserModel, formFields: FieldsInterface): UserModel => {

    const updatedUser = { ...currentUser };

    if (typeof formFields["emailAddress"].value === "string") {
        updatedUser.username = formFields["emailAddress"].value;
    }

    if (typeof formFields["emailAddress"].value === "string") {
        updatedUser.email = formFields["emailAddress"].value;
    }

    if (typeof formFields["firstName"].value === "string") {
        updatedUser.firstName = formFields["firstName"].value;
    }

    if (typeof formFields["lastName"].value === "string") {
        updatedUser.lastName = formFields["lastName"].value;
    }

    if (typeof formFields["contactName"].value === "string") {
        updatedUser.contactName = formFields["contactName"].value;
    }

    if (typeof formFields["phoneNumber"].value === "string") {
        updatedUser.phoneNumber = formFields["phoneNumber"].value;
    }

    if (typeof formFields["cellNumber"].value === "string") {
        updatedUser.cellNumber = formFields["cellNumber"].value;
    }

    if (typeof formFields["address1"].value === "string") {
        updatedUser.address = formFields["address1"].value;
    }

    if (typeof formFields["address2"].value === "string") {
        updatedUser.address2 = formFields["address2"].value;
    }

    if (typeof formFields["city"].value === "string") {
        updatedUser.city = formFields["city"].value;
    }

    if (typeof formFields["state"].value === "string") {
        updatedUser.state = formFields["state"].value;
    }

    if (typeof formFields["zip"].value === "string") {
        updatedUser.zip = formFields["zip"].value;
    }

    return updatedUser;

}

/**
 * Get change password fields.
 * @returns 
 */
export const getChangePasswordFields = (): FieldsInterface => {

    const passwordFields: FieldsInterface = {
        originalPassword: {
            fieldId: "originalPassword",
            formFieldId: "account-form-originalPassword",
            value: "",
            label: "Old Password",
            validated: "default",
            required: true,
            helperTextInvalid: "Please enter your original password."
        },
        newPassword: {
            fieldId: "newPassword",
            formFieldId: "account-form-newPassword",
            value: "",
            label: "New Password",
            validated: "default",
            required: true,
            helperTextInvalid: "The new password isn't strong enough."
        },
        confirmPassword: {
            fieldId: "confirmPassword",
            formFieldId: "account-form-confirmPassword",
            value: "",
            label: "Confirm Password",
            validated: "default",
            required: true,
            helperTextInvalid: "Doesn't match new password."
        },
    }

    return passwordFields;

}